<template>
  <div class="container p-article l-article-main">
    <!-- 內文頁主體 -->
    <div class="p-article__body">
      <div class="e-category">
        <div class="e-category__main">
          {{ datas.article.main_category }}
        </div>
        <div class="e-category__child">
          {{ datas.article.sub_category }}
        </div>
      </div>
      <span v-if="datas.article.type !== 'general'" :class="articleType(datas.article).style" class="e-type">
        {{ articleType(datas.article).text }}
      </span>
      <h1 class="p-article__title">
        {{ datas.article.title }}
      </h1>
      <p
        v-if="Object.keys(datas.article.outsource_company).length > 0"
        class="p-article__outsource-company"
      >
        圖文提供 /
        <a
          :href="datas.article.outsource_company.homepage"
          :title="`外網連結 - 另開視窗連結圖文提供者 ${datas.article.outsource_company.name}`"
          target="_blank"
          rel="noreferrer noopener"
        >
          {{ datas.article.outsource_company.name }}
        </a>
        <span class="author">
          {{ datas.article.outsource_company.name === author ? '' : author }}
        </span>
        <span class="publishTime">
          {{ publishTime }}
        </span>
      </p>
      <p v-else class="p-article-info">
        <span v-if="authorLinks.length" class="p-article-info__author">
          <span v-for="(group, groupIndex) in authorLinks" :key="group.role" class="author-group">
            {{ group.label + '：' }}<span v-for="(person, index) in group.names" :key="person.name" class="author-name">
              <nuxt-link :to="person.url" :title="`前往${person.name}的報導總覽`">{{ person.name }}</nuxt-link><span v-if="index < group.names.length - 1">、</span>
            </span>
            <span v-if="groupIndex < authorLinks.length - 1" /></span>
        </span>
        <time :datetime="datas.article.publish_at_time_zone" class="p-article-info__time" itemprop="datePublished">
          {{ publishTime }}
        </time>
      </p>
      <!-- 原判斷: 作者不只一人時則不使用連結 -->
      <!-- <p class="p-article-info">
        <span v-if="author" class="p-article-info__author">
          <nuxt-link v-if="authorUrl()" :to="`/author/${authorUrl().split('/author/')[1]}/`" title="前往此編輯報導總覽頁面">{{ author }}</nuxt-link>
          <template v-else>{{ author }}</template>
        </span>
      </p> -->
      <!-- Top Tag -->
      <div v-show="isOver18 === true" id="article-tag-top" class="l-tags__wrapper">
        <nuxt-link
          v-for="(tag, index) in datas.article.tags"
          :key="index"
          :to="`/search/${tag.trim()}/`"
          :title="`使用${tag.trim()}關鍵字前往搜尋頁並搜尋`"
          :rel="tag.length > 6 ? 'nofollow' : ''"
          class="e-tag l-tags__item"
        >
          {{ tag }}
        </nuxt-link>
      </div>
      <!-- Top Tag -->
      <!-- 18禁確認畫面 -->
      <div v-if="is18content === true && isOver18 === false" class="p-article__18">
        <div class="p-article__18-body">
          <div class="m-modal__18x-img">
            <img src="https://static.ctwant.com/images/dist/18+.svg" alt="確認年齡滿18圖示">
          </div>
          <p class="m-modal__18x-text">
            <img src="https://static.ctwant.com/images/dist/lock.svg" alt="確認年齡滿18鎖定圖示">
            本文含有成人內容  請確定您已年滿18歲
          </p>
        </div>
        <div class="p-article__18-footer">
          <button class="e-btn m-modal__btn m-modal__btn--refuse" title="確認未滿18歲" @click="notOver18">
            <img src="https://static.ctwant.com/images/dist/xx.svg" alt="未滿18圖示">
            我未滿18 歲
          </button>
          <button class="e-btn m-modal__btn m-modal__btn--confirm" title="確認已滿18歲" @click="over18">
            <img src="https://static.ctwant.com/images/dist/oo.svg" alt="已滿18圖示">
            我已滿18 歲
          </button>
        </div>
      </div>
      <!-- 18禁確認畫面 -->
      <!-- 主要內容區 -->
      <div v-show="isOver18 === true" ref="content" class="p-article__content">
        <!-- 封面圖及圖說 -->
        <div class="p-article__img-box">
          <img
            :src="selectImageSize(datas.article.cover)"
            :alt="datas.article.caption"
            width="858"
            height="452"
            class="p-article__img"
            onerror="this.src='https://static.ctwant.com/images/dist/default_cover_md.png'"
          >
          <!-- <div id="div-gpt-ad-1620032974174-0" ref="div-gpt-ad-1620032974174-0" style="width: 1px; height: 1px;" /> -->
          <p class="p-article__cover-graph">
            {{ datas.article.caption }}
          </p>
        </div>
        <!-- 封面圖及圖說 -->
        <ShareBar
          ref="shareBar"
          :base="'article'"
          :data-id="datas.article.article_id"
          :data-title="datas.article.title"
          :data-next="datas.next"
          :sharebar-fixed="sharebarFixed"
          @update="shareBarUpdateIsShowShare"
        />
        <div class="m-fontsize">
          <button class="e-btn m-fontsize__item" title="放大內文字級" aria-label="放大內文字級" @click="fontPlus">
            A+
          </button>
          <button class="e-btn m-fontsize__item" title="縮小內文字級" aria-label="縮小內文字級" @click="fontMinus">
            A-
          </button>
        </div>
        <article>
          <div
            ref="articleContent"
            :style="{ fontSize: `${articleFontSize}px` }"
            v-html="datas.article.content"
          />
          <!-- Bottom Tag -->
          <div id="article-tag-bottom" class="l-tags__wrapper bottom">
            <nuxt-link
              v-for="(tag, index) in datas.article.tags"
              :key="index"
              :to="`/search/${tag}/`"
              :title="`使用${tag}關鍵字前往搜尋頁並搜尋`"
              :rel="tag.length > 6 ? 'nofollow' : ''"
              class="e-tag l-tags__item"
            >
              {{ tag }}
            </nuxt-link>
          </div>
          <!-- Bottom Tag -->
        </article>
      </div>
      <!-- 主要內容區 -->
      <!-- 引文 -->
      <div v-if="datas.article.remark !== ''" class="m-remark">
        <p v-html="ReplaceNewline(datas.article.remark)" />
      </div>
      <!-- 引文 -->
      <!-- 文末影音 -->
      <div v-if="datas.article.video_bottom.youtube_id" class="e-video mb-1">
        <iframe
          :src="`https://www.youtube.com/embed/${datas.article.video_bottom.youtube_id}?autoplay=1&playlist=${datas.article.video_bottom.youtube_id}&loop=1&mute=1`"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
      <!-- 文末影音 -->
      <!-- 系列文章 -->
      <SeriesArticles
        v-show="isOver18 === true"
        :article-type="'article'"
        :series-data="datas.article.series"
        :topic-data="datas.article.topic"
      />
      <!-- 系列文章 -->
      <!-- 同類別額外五則 -->
      <!--
      <CategoryExtra
        :main-category="main_category"
        :sub-category="datas.article.sub_category"
        :category-extra-data="datas.category_extra"
      />
      -->
      <!-- 同類別額外五則 -->
      <div class="l-ad__wrapper mb-2 mt-1" style="min-height: 100px;">
        <div id="div-gpt-ad-1590467132070-0" ref="div-gpt-ad-1590467132070-0" />
      </div>
      <!-- 延伸閱讀 -->
      <ExtendedArticle v-show="isOver18 === true" :init-data="datas.article.extended" :latest-topic="datas.article.latest_topic" />
      <!-- 延伸閱讀 -->
      <div
        v-show="isOver18 === true"
        :class="{
          'mb-4': !isMobile,
          'mt-4': !isMobile,
          'mb-3': isMobile,
        }"
        class="l-ad__wrapper"
      >
        <div class="l-ad__banner">
          <!-- 暫時關閉 Google News 版位
          <Subscription
            :main-category="datas.article.main_category"
            :sub-category="datas.article.sub_category"
          />-->
          <div id="div-gpt-ad-1562662964306-0" ref="div-gpt-ad-1562662964306-0" style="height: 100px;" />
          <!-- 這一個 ad 目前已沒在使用
          <div id="div-gpt-ad-1563877894783-0" ref="div-gpt-ad-1563877894783-0" style="width: 1px; height: 1px;" /> -->
        </div>
      </div>
      <!-- 手機側邊欄 -->
      <SideBarForMobile :data="datas" />
      <!-- 手機側邊欄 -->
      <!-- 熱門推薦-->
      <div id="_popIn_recommend" ref="_popIn_recommend" style="min-height: 800px;" />
    </div>
    <!-- 內文頁主體 -->
    <!-- 側邊欄 -->
    <SideBar :data="datas" />
    <!-- 側邊欄 -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ShareBar from '@/components/ShareBar.vue'
import SeriesArticles from '@/components/SeriesArticles.vue'
import ExtendedArticle from '@/components/ExtendedArticle.vue'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'
// import CategoryExtra from '@/components/CategoryExtra.vue'
// import Subscription from '@/components/Subscription.vue'
import articleHelpers from '@/utils/articleHelpers.js'
import adTabIndexRemove from '@/utils/adTabIndexRemove.js'
import scrollToTop from '@/utils/scrollToTop.js'

export default {
  components: {
    ShareBar,
    SeriesArticles,
    ExtendedArticle,
    SideBar,
    SideBarForMobile
    // CategoryExtra
    // Subscription
  },
  mixins: [articleHelpers, adTabIndexRemove],
  validate({ params, redirect }) {
    if (/^\d+$/.test(params.id) === false) {
      redirect(301, '/')
    }
    return /^\d+$/.test(params.id)
  },
  async asyncData({ $axios, route, params, query, redirect, error }) {
    const api = $axios.defaults.baseURL
    // 後面的 ?t 是 CMS 文章按預覽時會附加的 timestamp, 為避免 CDN cache
    const url = `${api}/article/${params.id}${query.t ? `?t=${query.t}` : ''}`
    try {
      if (!params.id.match(/^\d+$/)) {
        throw new TypeError('error format article id', params.id)
      }
      if (route.path.substr(-1) !== '/' && Object.keys(query).length <= 0) {
        redirect(301, `${route.path}/`)
      }
      const { data } = await $axios.$get(url)
      return {
        datas: data,
        main_category: data.article.main_category,
        hasIG: data.article.content.includes('origin_instagram'),
        is18content: data.article.is_adult === 'Y'
      }
    } catch (e) {
      if (e instanceof TypeError) {
        console.error('Article', {
          code: 400,
          message: e.message
        })
        error({ statusCode: 400 })
      } else {
        console.error('Article', {
          code: e.response.data.code,
          message: e.response.data.message,
          method: e.response.config.method,
          url: e.response.config.url
        })
        error({ statusCode: 404 })
      }
    }
  },
  data() {
    return {
      datas: null,
      main_category: '',
      lastScrollTop: 0,
      sharebarFixed: false,
      isShowShare: false,
      pageScreenWidth: 0,
      articleFontSize: 18,
      hasIG: false,
      unwatchIsLogin: null,
      timeOut: null,
      is18content: false,
      isOver18: true
    }
  },
  head() {
    const articleData = {
      title: `${this.datas.article.title} | ${this.main_category} | CTWANT`,
      url: this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`),
      ampUrl: this.HOST + '/amp' + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`),
      thumbnailUrl: (this.datas.article.has_large_cover === 'Y') ? this.datas.article.cover.lg : this.datas.article.cover.md,
      coverIsLg: (this.datas.article.has_large_cover === 'Y'),
      caption: this.datas.article.caption,
      main_category: this.main_category,
      keywords: `${this.datas.article.title}, ${this.datas.article.tags.join(', ')}`,
      schema_keywords: this.datas.article.tags.join(', '),
      articleSection: this.main_category,
      description: `${this.datas.article.pure_content.replace(/<[^>]+>|&[^>]+;/g, '').trim().substr(0, 100)}...`,
      author: this.authorInfo.primaryAuthor,
      publishTime: this.datas.article.publish_at_time_zone,
      updateTime: this.datas.article.updated_at_time_zone,
      pure_content: this.datas.article.pure_content
    }
    let ImageObject = {
      '@context': 'http://schema.org',
      '@type': 'ImageObject',
      contentUrl: articleData.thumbnailUrl,
      caption: articleData.caption,
      height: (articleData.coverIsLg) ? '632' : '452',
      width: (articleData.coverIsLg) ? '1200' : '858'
    }
    const authorData = this.authorSchemaData
    const NewsArticle = {
      '@context': 'http://schema.org',
      '@type': 'NewsArticle',
      headline: articleData.title,
      url: articleData.url,
      thumbnailUrl: articleData.thumbnailUrl,
      articleSection: articleData.articleSection,
      keywords: articleData.schema_keywords,
      description: articleData.description,
      ImageObject,
      author: authorData.length === 1 ? authorData[0] : authorData,
      articleBody: articleData.pure_content,
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': articleData.url
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        url: this.HOST,
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/ctwant_logo_600x60.png',
          height: '60',
          width: '600'
        }
      },
      dateCreated: articleData.publishTime,
      datePublished: articleData.publishTime,
      dateModified: articleData.updateTime
    }
    const Article = { ...NewsArticle }
    Article['@type'] = 'Article'

    if (this.datas.article.content_images.length > 0) {
      const cover = { ...ImageObject }
      ImageObject = [cover]
      this.datas.article.content_images.forEach((contentImageItem) => {
        ImageObject.push({
          '@context': 'http://schema.org',
          '@type': 'ImageObject',
          contentUrl: contentImageItem.url,
          caption: contentImageItem.figcaption,
          height: contentImageItem.height,
          width: contentImageItem.width
        })
      })
    }

    const BreadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': this.HOST,
            name: 'CTWANT'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `${this.HOST}/category/${articleData.main_category}/`,
            name: articleData.main_category
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': articleData.url,
            name: articleData.title
          }
        }
      ]
    }
    let BreadcrumbListIncludeTopic = null
    if (Object.keys(this.datas.article.topic).length > 0) {
      BreadcrumbListIncludeTopic = JSON.parse(JSON.stringify(BreadcrumbList))
      BreadcrumbListIncludeTopic.itemListElement.splice(2, 0, {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@id': `${this.HOST}/topic/${this.datas.article.topic.topic_id}/`,
          name: this.datas.article.topic.title
        }
      })
      BreadcrumbListIncludeTopic.itemListElement[3].position = 4
    }
    const SeriesListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.datas.article.series.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover ? item.cover.md : '',
          url: `https://www.ctwant.com/article/${item.id}/`
        }
      })
    }
    const HotNewsListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.datas.popular.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `https://www.ctwant.com/article/${item.article_id}/`
        }
      }).slice(0, 5)
    }
    return {
      title: `${articleData.title}`,
      meta: [
        { hid: 'description', name: 'description', content: articleData.description },
        { hid: 'keywords', name: 'keywords', content: articleData.keywords },
        { hid: 'author', name: 'author', content: articleData.author || 'CTWANT' },
        { hid: 'ogUrl', property: 'og:url', content: articleData.url },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        { hid: 'ogTitle', property: 'og:title', content: articleData.title },
        { hid: 'ogDescription', property: 'og:description', content: articleData.description },
        {
          hid: 'max-image-preview',
          name: 'robots',
          content: articleData.coverIsLg ? 'max-image-preview:large' : 'max-image-preview:standard'
        },
        { hid: 'ogImage', property: 'og:image', content: articleData.thumbnailUrl },
        { hid: 'articlePublished_time', name: 'pubdate', property: 'article:published_time', itemprop: 'datePublished', content: articleData.publishTime },
        { hid: 'articleModified_time', name: 'lastmod', property: 'article:modified_time', itemprop: 'dateModified', content: articleData.updateTime },
        { hid: 'articleSection', property: 'article:section', itemprop: 'articleSection', content: articleData.main_category }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: articleData.url },
        { hid: 'canonical', rel: 'canonical', href: articleData.url },
        { rel: 'dns-prefetch', href: '//connect.facebook.net' },
        { rel: 'dns-prefetch', href: '//www.instagram.com' },
        { rel: 'dns-prefetch', href: '//api.instagram.com' },
        { hid: 'amphtml', rel: 'amphtml', href: articleData.ampUrl }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(NewsArticle), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(Article), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(ImageObject), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(BreadcrumbList), type: 'application/ld+json' },
        ...(BreadcrumbListIncludeTopic ? [{ innerHTML: JSON.stringify(BreadcrumbListIncludeTopic), type: 'application/ld+json' }] : []),
        { innerHTML: JSON.stringify(SeriesListItem.itemListElement.length > 0 ? SeriesListItem : HotNewsListItem), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapState('member', [
      'isLogin'
    ]),
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth',
      'scrollTop',
      'isMobile'
    ]),
    selectImageSize() {
      // const sw = this.pageScreenWidth
      return function (imageArr) {
        // let imgUrl
        const imgUrl = imageArr.md
        /*
        if (sw <= this.WIDTH_PAD) {
          imgUrl = imageArr.sm
        } else {
          imgUrl = imageArr.md
        }
        */
        return imgUrl
      }
    },
    authorInfo() {
      const participants = this.datas.article.participants
      const roleLabels = {
        reporter: '記者',
        editor: '編輯',
        author: '作者'
      }

      // 建立作者連結資料
      const authorGroups = []
      for (const role of ['reporter', 'editor', 'author']) {
        const namesRaw = participants[role]
        if (namesRaw && namesRaw.trim() !== '') {
          const names = namesRaw.split('、').map(name => name.trim())
          authorGroups.push({
            role,
            label: roleLabels[role],
            names: names.map(name => ({
              name,
              url: `/author/${role}/${encodeURIComponent(name)}/`
            }))
          })
        }
      }

      // 判斷是否為單一作者（用於 schema）
      const allParticipants = Object.values(participants).filter(p => p && p.trim() !== '')
      const hasOnlyOneRole = allParticipants.length === 1
      const singleAuthorData = hasOnlyOneRole ? allParticipants[0].split('、') : []
      const isSingleAuthor = hasOnlyOneRole && singleAuthorData.length === 1

      return {
        groups: authorGroups,
        isSingleAuthor,
        singleAuthorName: isSingleAuthor ? singleAuthorData[0] : '',
        singleAuthorRole: isSingleAuthor ? Object.keys(participants).find(role => participants[role].trim() !== '') : '',
        primaryAuthor: participants.reporter || participants.editor || participants.author || 'CTWANT'
      }
    },
    // 用於模板顯示的作者連結
    authorLinks() {
      return this.authorInfo.groups
    },
    // 用於向後相容的作者顯示文字
    author() {
      if (Object.keys(this.datas.article.outsource_company).length > 0) {
        const authorArr = []
        const participants = this.datas.article.participants
        for (const key in participants) {
          if (participants[key] !== '') {
            authorArr.push(participants[key])
          }
        }
        return authorArr.join('、')
      }

      const groups = this.authorInfo.groups
      if (groups.length === 0) {
        return ''
      }

      return groups.map((group) => {
        const names = group.names.map(person => person.name).join('、')
        return `${group.label}：${names}`
      }).join('　')
    },

    // 用於 schema 的作者資料（產生多個 Person 物件）
    authorSchemaData() {
      const { groups } = this.authorInfo
      const authors = []

      groups.forEach((group) => {
        group.names.forEach((person) => {
          authors.push({
            '@type': 'Person',
            name: person.name,
            url: `${this.HOST}${person.url}`
          })
        })
      })

      // 如果沒有作者，回傳預設的 CTWANT
      if (authors.length === 0) {
        return [{
          '@type': 'Person',
          name: 'CTWANT'
        }]
      }

      return authors
    },

    getUser() {
      return this.$store.state.user
    },
    publishTime() {
      return this.datas.article.publish_at.replace(/ /g, '　')
    }
  },
  watch: {
    scrollTop() {
      let contentOffsetTop = 0

      if (this.$refs.content !== undefined) {
        contentOffsetTop = this.$refs.content.getBoundingClientRect().top + this.scrollTop
      }

      if (this.scrollTop > contentOffsetTop && this.pageScreenWidth > this.WIDTH_PAD) {
        this.sharebarFixed = true
      } else {
        this.sharebarFixed = false
      }
    }
  },
  created() {
    if (this.datas.article.status !== 'publish' && this.is18content === false) {
      this.$store.dispatch('ad/disableAd')
    }
  },
  mounted() {
    this.pageScreenWidth = this.screenWidth || window.screen.width

    if (this.is18content === false) {
      this.init()
    } else {
      this.showOver18Modal()
    }
  },
  beforeDestroy() {
    if (this.is18content === true) {
      clearTimeout(this.timeOut)
    }
  },
  methods: {
    init() {
      this.beforeSendReadRecord()
      const userFontSize = JSON.parse(window.localStorage.getItem('fontSize'))
      if (userFontSize !== null) {
        this.articleFontSize = userFontSize
      }

      this.$nextTick(() => {
        this.fbVideoSetRWD()
        this.relateIframeRWD()

        // displayAd 要先被執行，因為 adult=Y 是在這裡被設定
        this.$store.dispatch('ad/displayAd', {
          isHideAd: this.datas.article.is_hide_ad,
          isOtherAd: this.datas.article.is_other_ad
        })
        this.$store.dispatch('ad/registerAndDisplayPopupAd', {
          type: this.main_category,
          isHideAd: this.datas.article.is_hide_ad
        })
        this.$gtm.push({
          event: 'domMounted',
          pageUrl: this.$route.fullPath,
          pageTitle: this.datas.article.title,
          pageCategory: this.main_category
        })
        // 讓後端統計即時流量用
        this.$axios.$post(`${this.$config.baseURL}/realtime-pv`, { url: window.location.href })

        if (this.isMobile === false) {
          this.$_adTabIndexRemoveFn([
            // this.$refs['div-gpt-ad-1620032974174-0'],
            document.getElementById('div-gpt-ad-1562665659288-0'),
            document.getElementById('div-gpt-ad-1566899414172-0'),
            document.getElementById('div-gpt-ad-1579516679912-0'),
            this.$refs['div-gpt-ad-1562662964306-0'],
            this.$refs['div-gpt-ad-1590467132070-0']
            // this.$refs['div-gpt-ad-1563877894783-0']
          ])
          this.$_adTabIndexRemoveFromTagA([
            this.$refs._popIn_recommend
          ])
        }
      })
      if (this.hasIG) {
        /* global instgrm */
        instgrm.Embeds.process()
      }
      this.reloadTikTok()
    },

    showOver18Modal() {
      const sessionOver18 = sessionStorage.getItem('over18')
      if (sessionOver18 !== 'true') {
        this.isOver18 = false
      } else {
        this.isOver18 = true
        if (this.datas.article.status !== 'publish') {
          this.$store.dispatch('ad/disableAd')
        }
        this.timeOut = setTimeout(() => {
          this.init()
        }, 200)
      }
    },
    notOver18() {
      this.$router.push({
        path: '/'
      })
    },
    over18() {
      this.isOver18 = true
      sessionStorage.setItem('over18', true)
      if (process.client) {
        scrollToTop(0, 1500, 'easeInOutQuint')
      }
      if (this.datas.article.status !== 'publish') {
        this.$store.dispatch('ad/disableAd')
      }
      this.timeOut = setTimeout(() => {
        this.init()
      }, 200)
    },
    fontPlus() {
      this.articleFontSize += 1
      localStorage.setItem('fontSize', this.articleFontSize)
    },
    fontMinus() {
      this.articleFontSize -= 1
      localStorage.setItem('fontSize', this.articleFontSize)
    },
    beforeSendReadRecord() {
      if (this.isLogin) {
        this.sendReadRecord()
        return
      }
      this.unwatchIsLogin = this.$watch('isLogin', function (val) {
        if (val) {
          this.sendReadRecord()
        }
        this.unwatchIsLogin()
      })
    },
    sendReadRecord() {
      this.$store.dispatch('member/sendArticleReadCount', this.$route.params.id)
    },
    shareBarUpdateIsShowShare(bool) {
      this.isShowShare = bool
    },
    fbVideoSetRWD() {
      // FB-影片 調整自適應
      const fbVideos = this.$refs.articleContent.querySelectorAll('.fb-video')
      if (fbVideos.length > 0) {
        fbVideos.forEach((videoDom) => {
          videoDom.querySelector('iframe').classList.add('fb-video-iframe')
          const iframeWidth = videoDom.querySelector('iframe').style.width.split('px')[0] || 300 // 寬高預設為 FB 影片最常見的 16:9
          const iframeHeight = videoDom.querySelector('iframe').style.height.split('px')[0] || 169
          const proportion = (iframeHeight / iframeWidth * 100).toFixed(2)
          videoDom.style.paddingBottom = `${proportion}%`
        })
      }
    },
    relateIframeRWD() {
      const relateIframeDoms = this.$refs.articleContent.querySelectorAll('.relate-iframe')
      if (relateIframeDoms.length > 0) {
        relateIframeDoms.forEach((relateIframe) => {
          const iframeWidth = relateIframe.querySelector('iframe').getAttribute('width') || 300
          const iframeHeight = relateIframe.querySelector('iframe').getAttribute('height') || 169
          const proportion = (iframeHeight / iframeWidth * 100).toFixed(2)
          relateIframe.style.paddingTop = `${proportion}%`
        })
      }
    },
    reloadTikTok() {
      if (this.pageScreenWidth < this.WIDTH_PAD) {
        const tiktokBlocks = document.querySelectorAll('.tiktok-embed')
        if (!tiktokBlocks || tiktokBlocks.length === 0) {
          return
        }
        for (let i = 0; i < tiktokBlocks.length; i++) {
          tiktokBlocks[i].removeAttribute('id')
        }
        const script = document.createElement('script')
        script.async = true
        script.src = 'https://www.tiktok.com/embed.js'
        script.setAttribute('id', 'tiktok-script')
        document.head.appendChild(script)
      }
    },
    shareFn() {
      this.$refs.shareBar.mobileShare()
    }
  }
}
</script>

<style>
/* 由於 amp 有使用 _article.scss 該css 有必要使用 !important ,所以這段style要額外引入使用 */
.article__embed .fb-video{
  width: 100%;
  height: 0;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.article__embed .fb-video .fb-video-iframe{
  width: 100% !important;
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
}
@media (max-width: 576px) {
  .article__embed .youtube-short{
    padding-bottom: 180% !important;
  }
}
</style>

<style lang="scss" scoped>
@import '~/assets/scss/modules/_modal';
@import '~/assets/scss/layout/_article-main';
@import '~/assets/scss/pages/_article';
</style>
